module.exports = __webpack_public_path__ + "static/media/contact.14ac0d70.png";